/* eslint-disable react/react-in-jsx-scope */
import { Box } from "@mui/material";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import CommonTextEditor from "src/components/CommonTextEditor/CommonTextEditor";

type Props = {
  closed: () => void;
  open: boolean;
  selectedData?: any;
  title?: string;
};

export default function CommonShowNotes({ closed, selectedData, open, title }: Props) {
  return (
    <>
      <CommonDrawer
        heading={title || "Notes"}
        isOpen={open}
        closeDrawer={() => {
          closed && closed();
        }}
        drawerWidth={800}
      >
        <Box mt={1.5}>
          <CommonTextEditor
            value={selectedData}
            name={title || "notes"}
            height={570}
            title={title || "Notes"}
            disabled
          />
        </Box>
      </CommonDrawer>
    </>
  );
}
